
declare type multiplier = "k"|"m"|"g";

const muls:Record<multiplier , number> = {
    "k": 1024,
    "m": 1048576,
    "g": 1073741824
};

export const parseFileSize = function (text: string | number) {


    if (isNaN(text as number) === false) {
        return (text as number) *1;
    }

    const match = /^([0-9]+)([kmg]?)$/.exec(String(text).toLowerCase().replace(/[^0-9kmg]/g, ''));
    let size = +match![1];
    const mul: string = match![2];

    if (muls.hasOwnProperty(mul) ) {
        size *= muls[mul as multiplier];
    }

    return size;
}

const sizes = ['Bytes', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']

export const getFileSizeString = function (size: number, decimals: number = 2) {


    if (!+size) return '0 Bytes'

    const k = 1024
    const dm = decimals < 0 ? 0 : decimals
    

    const i = Math.floor(Math.log(size) / Math.log(k))

    const n = size / Math.pow(k, i);
    return n.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: dm }) + " " + sizes[i];

    
}
